import { nodeInstance } from "@/plugins/axios";

const eventChatService = {};

eventChatService.sendMessage = (eventId, message) => {
  return nodeInstance.post(`/api/event/${eventId}/chat`, { message });
};

eventChatService.getMessages = (eventId, take = 50, skip = 0) => {
  return nodeInstance.get(`/api/event/${eventId}/chat`, { params: { take, skip } });
};

export default eventChatService;
